import { render, staticRenderFns } from "./UserCompilaQuestionario.vue?vue&type=template&id=3e578af7&"
import script from "./UserCompilaQuestionario.vue?vue&type=script&lang=js&"
export * from "./UserCompilaQuestionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports